<template>
    <div class="form-group">
        <label class="label">
            Insurance
            <small>( Add Value for Dry / Frozen accordingly )</small>
        </label>
        <div class="col-12 row p-0">
            <div class="col-4 p-0">
                <app-input 
                    type="text"
                    v-model="displayData"
                    :placeholder="'Data'"
                    :required="true"
                    :disabled="true"
                    @blur="rawInputData = ''" 
                />
            </div>
            <div class="col-4 p-0">
                <app-input 
                   :placeholder="$t('Factor')"
                    type="number"
                    v-model="internalValue.factor"
                    :required="true"
                    @input="updateValue"
                    :disabled="is_view"
                />
            </div>
            <div class="col-4 p-0">
                <app-input 
                    type="text"
                    v-model="displayValue"
                    :placeholder="'Value'"
                    :required="true"
                    :disabled="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Insurance',
    props: {
        value: {
            type: Object,
            default: () => ({
                data: '',
                value: '',
                factor : ''
            })
        },
        is_view : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            rawInputData: '',  
            isTypingDotData: false,
            internalValue: { ...this.value }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        },
        // NUEVO: Escucha cambios en el Data interno y avisa al Padre
        'internalValue.data': function(nuevoData) {
            this.updateValue(); 
        }
    },
    computed: {
        displayValue: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === undefined || val === '') return '$ 0.000';
                
                // Usamos Intl.NumberFormat para manejar millones y decimales
                return new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 3,
                    maximumFractionDigits: 3
                }).format(val);
            },
            set(newValue) {
                let cleanValue = String(newValue).replace(/[^0-9.]/g, '');
                let numericValue = parseFloat(cleanValue);
                this.internalValue.value = isNaN(numericValue) ? 0 : numericValue;
                this.updateValue();
            }
        },
        displayData: {
            get() {
                const val = this.internalValue.data;
                if (val === null || val === '') return this.rawInputData || '$ 0';

                // Si el usuario está escribiendo, mostramos el raw
                if (this.rawInputData !== '') return '$ ' + this.rawInputData;

                return '$ ' + new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInputData = cleanValue;  // guardamos el string tal cual

                if (cleanValue.endsWith('.')) {
                    this.isTypingDotData = true;
                    return;
                }

                this.isTypingDotData = false;

                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);

                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.data = numericValue;
                    this.updateValue();
                }
            }
        },
    },
    methods: {
        updateValue() {
            this.$emit('input', { 
                data: this.internalValue.data, 
                value: this.internalValue.value,
                factor: this.internalValue.factor,
            });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>